import i18n from "@/langs/i18n";

export function getAll() {
  var items = [
    {
      value: 0,
      name: "None",
      text: `${i18n.t("option.systemLogType.None")}`,
    },
    {
      value: 1,
      name: "DeviceChangeCpu",
      text: `${i18n.t("option.systemLogType.DeviceChangeCpu")}`,
    },
    {
      value: 2,
      name: "UserChangePassword",
      text: `${i18n.t("option.systemLogType.UserChangePassword")}`,
    },
    {
      value: 3,
      name: "SystemChangeUserPassword",
      text: `${i18n.t("option.systemLogType.SystemChangeUserPassword")}`,
    },
    {
      value: 4,
      name: "InitailizeSale",
      text: `${i18n.t("option.systemLogType.InitailizeSale")}`,
    },
    {
      value: 5,
      name: "InitailizeERP",
      text: `${i18n.t("option.systemLogType.InitailizeERP")}`,
    },
    {
      value: 6,
      name: "DeleteUberEats",
      text: `${i18n.t("option.systemLogType.DeleteUberEats")}`,
    },
    {
      value: 7,
      name: "ReuploadDeposit",
      text: `${i18n.t("option.systemLogType.ReuploadDeposit")}`,
    },
    {
      value: 8,
      name: "ReuploadIntegral",
      text: `${i18n.t("option.systemLogType.ReuploadIntegral")}`,
    },
    {
      value: 9,
      name: "DeleteBusiness",
      text: `${i18n.t("option.systemLogType.DeleteBusiness")}`,
    },
    {
      value: 10,
      name: "DeleteDevice",
      text: `${i18n.t("option.systemLogType.DeleteDevice")}`,
    },
    {
      value: 11,
      name: "TransferSaler",
      text: `${i18n.t("option.systemLogType.TransferSaler")}`,
    },
    {
      value: 12,
      name: "DeleteUser",
      text: `${i18n.t("option.systemLogType.DeleteUser")}`,
    },
    {
      value: 13,
      name: "GenerateLicense",
      text: `${i18n.t("option.systemLogType.GenerateLicense")}`,
    },
    {
      value: 14,
      name: "DeleteLicense",
      text: `${i18n.t("option.systemLogType.DeleteLicense")}`,
    },
    {
      value: 15,
      name: "ClearLicense",
      text: `${i18n.t("option.systemLogType.ClearLicense")}`,
    },
    {
      value: 16,
      name: "DeviceVersionUpgrade",
      text: `${i18n.t("option.systemLogType.DeviceVersionUpgrade")}`,
    },
    {
      value: 17,
      name: "PadSettingDownload",
      text: `${i18n.t("option.systemLogType.PadSettingDownload")}`,
    },
    {
      value: 18,
      name: "PadAppInstall",
      text: `${i18n.t("option.systemLogType.PadAppInstall")}`,
    },
    {
      value: 19,
      name: "PadCoreDataEmpty",
      text: `${i18n.t("option.systemLogType.PadCoreDataEmpty")}`,
    },
    {
      value: 20,
      name: "ElecInvoiceSync",
      text: "電子發票同步",
    },
    {
      value: 21,
      name: "ElecInvoiceUpload",
      text: "電子發票上傳",
    },
  ];
  return items;
}

export function getByName(name) {
  const type = getAll().find(function (item) {
    return item.name.toLowerCase() == name.toLowerCase();
  });
  return type;
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
